import { MY_TASKS_KEY } from '@witty-board/shared'

/**
 * Rutas de las vistas sobre las que se abre el panel de tarea: el tablero de
 * un proyecto, el Inicio (`MY_TASKS_KEY`) o la vista de una columna (fase 7).
 * Con `status`, la vista de columna; sin él, el tablero.
 */
export function boardViewPath(key: string, status?: string): string {
  if (status) return `/projects/${key}/columns/${status}`
  return key === MY_TASKS_KEY ? '/' : `/projects/${key}`
}

/** Ruta del panel de una tarea abierto sobre esa misma vista, para no cambiar el fondo al abrirla. */
export function taskPanelPath(key: string, taskId: string, status?: string): string {
  const base = status ? `/projects/${key}/columns/${status}` : `/projects/${key}`
  return `${base}/tasks/${taskId}`
}
